export const apiConstants = {
  url: "/api/courseCategory"
};
